// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S2md","name":"styles_name__19Op_","phone":"styles_phone__2lRhQ"};